/**
 * Builds the list of per-team rows for the finance-ledger TEAM-mode credits
 * dropdown.  Mirrors the contractCreditsBalance admin/non-admin filtering in
 * SubscriptionsCreditsInfo so the UI shows the same team set regardless of
 * which billing backend is active.
 *
 * Pure function — no side-effects, safe to unit-test without a render.
 *
 * @param {Object} params
 * @param {boolean} params.hasAdminRole   - True when the user has MANAGE_ORGANISATION or is a Shootsta admin/tech-support
 * @param {Array}   params.orgTeams       - All org teams from the Credits context (for imageUrl resolution)
 * @param {Array}   params.userTeams      - The user's own teams (used when not admin)
 * @param {Array}   params.teamBalances   - [{teamId, teamName, creditsRemaining}] from getFinanceBalance
 * @return {Array} [{teamId, name, imageUrl, creditsRemaining}]
 */
export default function buildFinanceTeamRows({
  hasAdminRole,
  orgTeams = [],
  userTeams = [],
  teamBalances = []
}) {
  // Admin sees all org teams; regular member sees only the teams they belong to.
  const visibleTeams = hasAdminRole ? orgTeams : userTeams;

  return visibleTeams.map((team) => {
    const ledgerEntry = teamBalances.find((t) => t.teamId === team.teamId);
    return {
      teamId: team.teamId,
      name: team.name || team.teamName || '',
      imageUrl: orgTeams.find((t) => t.teamId === team.teamId)?.imageUrl || '',
      creditsRemaining: ledgerEntry ? ledgerEntry.creditsRemaining : 0
    };
  });
}
